var site = site || {};
var generic = generic || {};
var Mustache = Mustache || {};
var prodcat = prodcat || {};

(function ($) {
  'use strict';

  Drupal.behaviors.foundationFinderV1 = {
    attach: function (context) {
      // Initializes foundation finder, adding inline product templates which will need re-processing.
      this.init(context);

      // @todo bandaid to re-invoke the dependent product_ui functionality
      // Forces product lib to reprocess these newly added DOM elements from foundation finder
      var products = prodcat.data.collectProductIds();

      $(window).trigger('prodcat:UiInitialized', [products]);
    },
    init: function (context) {
      var self = this;
      // Get the foundation finder products from page data.
      var pageDataResult = self.getPageData();
      var $step_1_Data = [];
      var $step_2_Data = [];
      var $step_3_Data = [];
      var $foundationFinderContainer = $('.foundation-finder', context);
      var $foundationFinderAnimateWrapper = $('.foundation-finder__animatewrap', context);
      var $setpOneContainer = $('.js-foundation-finder-one', context);
      var $foundationFinderStep = $('.js-foundation-finder-step', context);
      var $stepOneQuizButton = $setpOneContainer.find('.js-step-one');
      var $goPrevStep = $('.js-navigate-prev', context);
      var $stepPopupClose = $('.js-foundation-finder-close', context);
      var $stepTwoContainer = $('.js-foundation-finder-two', context);
      var $stepTwoQuizButton = $stepTwoContainer.find('.js-foundation-finder-row');
      var $stepUndertone = $('.js-foundation-finder-undertone');
      var $stepCloseUndertone = $('.js-foundation-finder-undertone-close');
      var $stepThreeContainer = $('.js-foundation-finder-three', context);
      var $stepThreeSliderSlick = $('.foundation-finder__slider', context);
      var $finderResult = $('.foundation-finder__details', context);
      var $complementaryProducts = $('.mpp-complementary-products-v1', context);
      var $foundationFinder = $('.foundation-finder', context);
      var $sectionAnimate = $('.foundation-finder__animatestep', context);
      var stepTwoHeight;
      var stepThreeHeight;
      var stepAnimateHeight;

      // Load the shade finder product on page loads.
      self.loadFinderProducts(pageDataResult, $finderResult, $foundationFinderContainer, $complementaryProducts);

      $foundationFinderStep.once().click(function () {
        var finderStep = $(this).closest('.foundation-finder__step');
        var $foundationOverlay = finderStep.next().find('.foundation-finder__inner');
        var transformAnimateHeight = finderStep.height();
        var offsetTop;
        var getElementHeight = {
          windowHeight: $(window).height(),
          headerHeight: $('header').outerHeight(true),
          loyaltyStickyHeight: $('.mac-select-loyalty-footer-formatter').outerHeight(true),
          finderStepHeight: finderStep.outerHeight(true)
        };

        if (getElementHeight.windowHeight < getElementHeight.finderStepHeight) {
          offsetTop = (getElementHeight.windowHeight - (getElementHeight.headerHeight + getElementHeight.loyaltyStickyHeight)) / 2;
        }
        $foundationOverlay.css({
          'top': offsetTop + 'px'
        });
        if (finderStep.hasClass('foundation-finder__landing')) {
          $foundationFinderContainer.find('.foundation-finder__animate').removeClass('hidden').addClass('animated fadeInUp faster');
        }
        if (!finderStep.next().hasClass('foundation-finder__three')) {
          $foundationFinderAnimateWrapper.removeClass('transformend');
          finderStep.next().removeClass('hidden');
          $foundationFinderAnimateWrapper.css({
            'transform': 'translate3d(0px, -' + transformAnimateHeight + 'px , 0px)'
          });
          $foundationFinderAnimateWrapper.one('transitionend', function () {
            $foundationFinderContainer.find('.foundation-finder__animate').addClass('hidden').removeClass('animated');
            $foundationFinderAnimateWrapper.addClass('transformend');
            finderStep.css({
              'max-height': 0
            });
            $foundationFinderAnimateWrapper.css({
              'transform': 'translate3d(0px,  0px , 0px)'
            });
            finderStep.next().find('.foundation-finder__inner').eq(0).removeClass('hidden').children().addClass('animated fadeInUp');
          });
        }
      });

      $goPrevStep.on('click', function (e) {
        e.stopPropagation();
        var that = $(this);
        var finderStep = that.closest('.foundation-finder__step');
        var finderSlick = finderStep.find('.foundation-finder__slider');

        finderStep.find('.foundation-finder__category').addClass('hidden');
        if (!finderStep.hasClass('foundation-finder__three')) {
          finderStep.parent().prev().removeClass('hidden');
          finderStep.parent().prev().animate({
            maxHeight: 1300
          }, {
            easing: 'linear',
            duration: 900
          });
        } else {
          $stepThreeContainer.css({
            'max-height': stepAnimateHeight + 'px'
          });
          finderStep.prev().removeClass('hidden');
          $sectionAnimate.removeClass('foundation-finder__animatemove')
            .one('transitionend', function () {
              $stepTwoContainer.css({
                'max-height': 'none'
              });
              $stepThreeContainer.css({
                'max-height': 'none'
              });
              finderSlick.empty().unslick();
            });
        }
      });

      $stepPopupClose.once().click(function (e) {
        e.preventDefault();
        var stepClose = $(this).closest('.foundation-finder__step');

        stepClose.find('.js-navigate-prev').addClass('foundation-finder__step--active');
        stepClose.removeClass('foundation-finder__grayscale');
        stepClose.find('.foundation-finder__steps').removeClass('hidden');
        stepClose.find('.js-foundation-finder-caption').addClass('animated fadeOutUp fast');
      });

      $stepUndertone.on('click', function (e) {
        e.stopPropagation();
        var finderUndertone = $(this);
        var finderCaption = finderUndertone.closest('.js-foundation-finder-caption');
        var finderStep = finderUndertone.closest('.foundation-finder__step');

        finderStep.find('.foundation-finder__popup').addClass('foundation-finder__show');
        finderStep.addClass('foundation-finder__grayscale');
        if (finderCaption.is(':visible')) {
          finderStep.addClass('js-foundation-finder-overlay');
          finderCaption.addClass('hidden');
        }
      });

      $stepCloseUndertone.on('click', function () {
        var finderCloseUndertone = $(this);
        var finderCloseCaption = finderCloseUndertone.closest('.foundation-finder__step');
        var finderCaptionToggle = finderCloseCaption.find('.js-foundation-finder-caption');

        finderCloseCaption.find('.foundation-finder__popup').removeClass('foundation-finder__show');
        if (finderCloseCaption.hasClass('js-foundation-finder-overlay')) {
          finderCaptionToggle.removeClass('hidden');
          finderCloseCaption.removeClass('js-foundation-finder-overlay');
        } else {
          finderCloseCaption.removeClass('foundation-finder__grayscale');
          finderCaptionToggle.addClass('hidden');
        }
      });

      $stepOneQuizButton.on('click', function () {
        var step_1_answer = $(this).attr('data-shade-name');

        $step_1_Data = self.filterSkuLevel($.extend(true, {}, pageDataResult), 'INTENSITY', step_1_answer);
        $stepTwoContainer.find('.foundation-finder__category[data-shade-name="' + step_1_answer + '"]').removeClass('hidden');
        $sectionAnimate.addClass('animate');
      });

      $stepTwoQuizButton.on('click', function () {
        var isMobile = site.client.isMobile;
        var setResultCount;
        var step_2_answer = $(this).attr('data-undertone');
        var isRTL = site.direction.isRTL && Drupal?.settings?.forceSlickRTL;

        $step_2_Data = self.filterSkuLevel($.extend(true, {}, $step_1_Data), 'UNDERTONE', step_2_answer);
        var resultCount = self.setSliderImages($step_2_Data, $stepThreeContainer);
        var centerPaddingVal = resultCount < 3 ? 0 : '27%';

        stepTwoHeight = $stepTwoContainer.outerHeight(true);
        $sectionAnimate.css({
          'max-height': stepTwoHeight + 'px'
        });
        $foundationFinderContainer.find('.foundation-finder--loader, .foundation-finder__animate').removeClass('hidden');
        $stepThreeSliderSlick.slick({
          onInit: function (slider) {
            var count = 0;
            var slideCount = slider.slideCount;
            var $getActiveSlide = $stepThreeSliderSlick.find('.slick-active');
            var transformDirection = site.direction.isRTL ? '' : '-';
            var animatePosition = transformDirection ? 'Right' : 'Left';

            $stepThreeSliderSlick.find('img').load(function () {
              count++;
              if (count === slideCount) {
                stepThreeHeight = $stepThreeContainer.outerHeight(true);
                stepTwoHeight < stepThreeHeight ? stepAnimateHeight = stepTwoHeight : stepAnimateHeight = stepThreeHeight;
                $sectionAnimate.css({
                  'max-height': stepAnimateHeight + 'px'
                });
                $stepTwoContainer.css({
                  'max-height': stepAnimateHeight + 'px'
                });
                $foundationFinderContainer.find('.foundation-finder__animate').addClass('hidden');
                $sectionAnimate.addClass('foundation-finder__animatemove');
                $stepThreeContainer.find('.foundation-finder__inner').removeClass('hidden');
                $stepThreeContainer.find('.foundation-finder__inner').children().addClass('animated fadeInUp');
                $getActiveSlide.prev().addClass('animated slideIn' + animatePosition + ' foundation-finder__box--delay1');
                $getActiveSlide.addClass('animated slideIn' + animatePosition + ' foundation-finder__box--delay2');
                $getActiveSlide.next().addClass('animated slideIn' + animatePosition + ' foundation-finder__box--delay3');
                $getActiveSlide.find('.foundation-finder__shade').addClass('animated slideInUp foundation-finder__box--delay4')
                  .one('animationend', function () {
                    $sectionAnimate.css({
                      'max-height': 'none'
                    });
                    $getActiveSlide.find('.foundation-finder__shade').removeClass('slideInUp');
                  });
              }
            });
          },
          slidesToShow: 1,
          slidesToScroll: 1,
          centerMode: true,
          rtl: isRTL,
          centerPadding: centerPaddingVal,
          responsive: [
            {
              breakpoint: 1024,
              settings: {
                centerPadding: 0
              }
            }
          ]
        });
        setResultCount = resultCount < 3 && resultCount !== 1 ? resultCount : 3;
        if (resultCount < 3 && !isMobile) {
          $stepThreeContainer.find('.slick-track').addClass('foundation-finder__setslider');
          $stepThreeContainer.find('.foundation-finder__shade').addClass('active');
          $stepThreeSliderSlick.slickSetOption('slidesToShow', setResultCount, true);
        }
      });

      $('body').once().on('click', '.foundation-finder__box', function (e) {
        e.preventDefault();
        $sectionAnimate.addClass('hidden');
        var step_3_answer = $(this).attr('data-shade-name');

        $step_3_Data = self.filterSkuLevel($.extend(true, {}, $step_2_Data), 'SHADENAME', step_3_answer);
        $stepThreeContainer.addClass('hidden');
        $finderResult.removeClass('hidden');
        $(window).scrollTop(0);
        self.displayResultShade($finderResult, $step_3_Data);
        self.displayResults($finderResult, $step_3_Data, $foundationFinderContainer, $complementaryProducts);
        $foundationFinder.closest('.foundation-finder__wrapper').addClass('result-active');
      });
      $foundationFinder.closest('#main_content').addClass('foundation-finder__wrapper');
    },
    getPageData: function () {
      var pageData = generic.page_data('consolidated-products');

      return pageData.get('products');
    },
    loadFinderProducts: function (pageDataResult, resultContainer, foundationFinderContainer, complementaryProducts) {
      var template_data = site.templates['ff_result_v1'];
      var partials = {};
      var template = $('script.inline-template[path="ff_result_v1"]').html();
      var productHTML;

      if (!_.isUndefined(template_data.partials)) {
        $.each(template_data.partials, function (key, name) {
          if (_.isUndefined(site.templates[name])) {
            throw new Error('The partial ' + name + ' cannot be found');
          }
          partials[key] = site.templates[name].content;
        });
      }
      for (var i = 0; i < pageDataResult.length; i++) {
        productHTML = Mustache.render(template, pageDataResult[i], partials);
        if (pageDataResult[i]['skus'][0]['PRODUCT_FORM'] === 'Powder') {
          resultContainer.find('.js-result-powder').html(productHTML);
        } else if (pageDataResult[i]['skus'][0]['PRODUCT_FORM'] === 'Liquid') {
          resultContainer.find('.js-result-liquid').html(productHTML);
        }
      }
      foundationFinderContainer.find('.product__reviews-spp').addClass('hidden');
      complementaryProducts.find('.mpp-complementary-products').addClass('hidden');
      complementaryProducts.find('.mpp-custom__header').addClass('hidden');
    },
    /* To filter the sku based on the filter value
     *  Args : results - Products array
     *  prop - Product cache field name
     *  filterValue - User quiz selection
     */
    filterSkuLevel: function (results, prop, filterValue) {
      var filterProducts = [];
      var skuFilterItems;
      var filSkus;
      var finderAnswer;
      var i = 0;

      if (results) {
        $.each(results, function (prodInd, prodListItem) {
          filSkus = [];
          $(prodListItem['skus']).each(function (skusInd, skusListItem) {
            if (skusListItem[prop]) {
              finderAnswer = skusListItem[prop];
              skuFilterItems = finderAnswer.toString().split(',');
              $.each(skuFilterItems, function (index, ele) {
                if (ele.toLowerCase().trim() === filterValue.toLowerCase().trim()) {
                  filSkus.push(skusListItem);
                }
              });
            }
          });
          if (filSkus.length > 0) {
            filterProducts.push(prodListItem);
            filterProducts[i]['skus'] = filSkus;
            i++;
          }
        });

        return filterProducts;
      }
    },
    setSliderImages: function (prodData, sliderContainer) {
      var $sliderslick = sliderContainer.find('.foundation-finder__slider');
      var devicePath = site.client.isMobile ? 'mobile' : 'pc';
      var imageContainer;
      var shadeContainer;
      var parsedShadeName;
      var productShadeName;
      var selectShadeCopy = sliderContainer.attr('data-select-shade');
      var resultCount = 0;

      $.each(prodData, function (prodInd, prodListItem) {
        $(prodListItem['skus']).each(function (skusInd, skusListItem) {
          productShadeName = skusListItem['SHADENAME'];
          parsedShadeName = productShadeName.replace('.', '_');
          if (skusListItem['PRODUCT_FORM'] === 'Powder') {
            return;
          }
          imageContainer = $('<div/>', {
            class: 'foundation-finder__box',
            'data-shade-name': productShadeName,
            'data-position': productShadeName.replace(/[^\d.]/g, '')
          }).appendTo($sliderslick);
          $('<img/>').attr({
            'src': '/media/export/cms/foundation_finder/step_three_' + devicePath + '/mac_sku_' + parsedShadeName + '.jpg'
          }).appendTo(imageContainer);
          shadeContainer = $('<div/>', {
            class: 'foundation-finder__shade'
          }).appendTo(imageContainer);
          $('<span/>').attr({
            'style': 'color:' + skusListItem['HEX_VALUE_STRING']
          }).html(productShadeName.replace(/[^\d.]/g, '')).appendTo(shadeContainer);
          $('<small/>').html(selectShadeCopy).appendTo(shadeContainer);
          resultCount++;
        });
      });
      $sliderslick.find('.foundation-finder__box').sort(function (a, b) {
        return $(a).data('position') - $(b).data('position');
      }).appendTo($sliderslick);

      return resultCount;
    },
    displayResults: function (resultContainer, resultData, foundationFinderContainer, complementaryProducts) {
      // To do. Yet to add the SKU_REPLACEMENT ids.
      var self = this;
      var currentli;
      var shadeData;
      var skuID;
      var resultPowder = resultContainer.find('.js-powder-container');
      var resultLiquid = resultContainer.find('.js-liquid-container');
      var liquidLinkTop = resultContainer.find('.js-liquid-link');
      var powderLinkTop = resultContainer.find('.js-powder-link');
      var prodForm;
      var lighterSkuId;
      var darkerSkuId;
      var skuDetails;
      var finderResultSKU;
      var resultSkuList = {};
      var shadeContainer;
      var appendShade;
      var sortList;
      var displayShadePicker;
      var shadeDetailsContainer;
      var resultCopyData;
      var resultSkuItems = [];

      foundationFinderContainer.find('.pr-snippet-read-and-write').addClass('hidden');
      complementaryProducts.find('.mpp-complementary-products').removeClass('hidden');
      complementaryProducts.find('.mpp-custom__header').removeClass('hidden');
      resultContainer.append(complementaryProducts);
      displayShadePicker = function (resultSkuList, resultContainer) {
        resultCopyData = resultContainer.parent().data();
        resultCopyData = resultCopyData.attr;
        appendShade = resultContainer.find('.shade-picker__colors');
        sortList = function (a, b) {
          return $(b).data('position') < $(a).data('position') ? 1 : -1;
        };
        resultContainer.find('.shade-picker__colors li').each(function () {
          currentli = $(this);
          shadeDetailsContainer = currentli.find('.shade-picker__color-details');
          shadeContainer = $('<div/>', {
            class: 'shade-picker__resultshade'
          });
          shadeData = currentli.attr('data-product');
          skuID = $.parseJSON(shadeData);
          if (resultSkuList.resultSku === skuID.sku) {
            currentli.attr('data-position', '1');
            shadeContainer.html(resultCopyData.yourShade).prependTo(shadeDetailsContainer);
          } else if (resultSkuList.lighterSku === skuID.sku) {
            currentli.attr('data-position', '2');
            shadeContainer.html(resultCopyData.lighterShade).prependTo(shadeDetailsContainer);
          } else if (resultSkuList.darkerSku === skuID.sku) {
            currentli.attr('data-position', '3');
            shadeContainer.html(resultCopyData.darkerShade).prependTo(shadeDetailsContainer);
          } else {
            currentli.remove();
          }
        });
        resultContainer.find('.shade-picker__colors li').sort(sortList).appendTo(appendShade);
        resultSkuItems = Object.keys(resultSkuList).map(function (e) {
          return resultSkuList[e];
        });
        resultContainer.find('#js-shade-picker-dropdown--product-full option').each(function () {
          var that = $(this);

          if ($.inArray(that.val(), resultSkuItems) === -1) {
            that.remove();
          }
        });
      };
      complementaryProducts.find('.expando-block__title').on('click', function () {
        $(this).closest('.expando-block__title').toggleClass('mpp-complementary-products');
      });
      resultPowder.on('click', '.expando-block', function () {
        $(this).toggleClass('expando-block--expanded');
      });
      resultLiquid.on('click', '.expando-block', function () {
        var that = $(this);

        if (that.hasClass('expando-block--expanded')) {
          that.addClass('expando-block--expanded');
        } else {
          that.removeClass('expando-block--expanded');
        }
      });
      complementaryProducts.find('.js-expando-block-trigger').trigger('click');
      $.each(resultData, function (prodInd, prodListItem) {
        skuDetails = prodListItem['skus'][0];
        prodForm = skuDetails['PRODUCT_FORM'];
        finderResultSKU = skuDetails['SKU_ID'];
        lighterSkuId = skuDetails['SKU_REPLACEMENT_1'] ? self.getSkuID(skuDetails['SKU_REPLACEMENT_1']) : '';
        darkerSkuId = skuDetails['SKU_REPLACEMENT_2'] ? self.getSkuID(skuDetails['SKU_REPLACEMENT_2']) : '';
        resultSkuList = {
          'resultSku': finderResultSKU,
          'lighterSku': lighterSkuId,
          'darkerSku': darkerSkuId
        };
        if (prodForm === 'Powder') {
          displayShadePicker(resultSkuList, resultPowder);
          resultPowder.add(powderLinkTop).removeClass('hidden');
          resultPowder.find('.shade-picker__colors li').eq(0).trigger('click');
        } else if (prodForm === 'Liquid') {
          displayShadePicker(resultSkuList, resultLiquid);
          resultLiquid.add(liquidLinkTop).removeClass('hidden');
          resultLiquid.find('.shade-picker__colors li').eq(0).trigger('click');
        }
        resultContainer.find('.js-product__edd--pc').addClass('hidden');
      });
      $(document).trigger('FoundationFinderResults', {
        liquid: resultLiquid,
        powder: resultPowder
      });
    },
    getSkuID: function (prodCode) {
      var self = this;
      var pageDataResult = self.getPageData();
      var skuID;

      $.each(pageDataResult, function (prodInd, prodListItem) {
        $(prodListItem['skus']).each(function (skusInd, skusListItem) {
          if (skusListItem['PRODUCT_CODE'] === prodCode) {
            skuID = skusListItem['SKU_ID'];
          }
        });
      });

      return skuID;
    },
    displayResultShade: function (resultContainer, resultData) {
      var shadeName = resultData[0] ? resultData[0].skus[0]['SHADENAME'] : '';
      var parsedShadeName = shadeName.replace('.', '_');
      var shadeDescription = resultData[0] && resultData[0].skus[0]['SHADE_DESCRIPTION'] !== null ? resultData[0].skus[0]['SHADE_DESCRIPTION'] : '';
      var devicePath = site.client.isMobile ? 'mobile' : 'pc';

      resultContainer.find('.js-result-top').removeClass('hidden');
      resultContainer.find('.js-foundation-finder-result').css({
        'background-image': 'url(/media/export/cms/foundation_finder/result_shades_' + devicePath + '/mac_sku_' + parsedShadeName + '.jpg)'
      });
      resultContainer.find('.js-result-shade-name').text(shadeName);
      resultContainer.find('.js-result-shade-desc').text(shadeDescription);
    }
  };
})(jQuery);

(function () {
  document.addEventListener('lazybeforeunveil', function (e) {
    var bg = e.target.getAttribute('data-bg');

    if (bg) {
      e.target.style.backgroundImage = 'url(' + bg + ')';
    }
  });
})();
